import { render, staticRenderFns } from "./u-footer-body-basic.vue?vue&type=template&id=438996bf&scoped=true&"
import script from "./u-footer-body-basic.vue?vue&type=script&lang=js&"
export * from "./u-footer-body-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-footer-body-basic.vue?vue&type=style&index=0&id=438996bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438996bf",
  null
  
)

export default component.exports